import { render } from "./EditGroup.vue?vue&type=template&id=3a3d3828&scoped=true"
import script from "./EditGroup.vue?vue&type=script&lang=js"
export * from "./EditGroup.vue?vue&type=script&lang=js"

import "./EditGroup.vue?vue&type=style&index=0&id=3a3d3828&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3d3828"]])

export default __exports__